import { ProductTypes, ReferenceUnit } from "$lib/constants";
import type { AddonData } from "$lib/products/misc";
import type { Product } from "$lib/server/database/drizzle-schemas";
import { useConfiguratorStore, type AdditionOptions } from "$lib/store/configurator.store";
import { useEffectiveRoofStore } from "$lib/store/configurator.effective.store";
// import { toast } from "svelte-sonner";
import { get } from "svelte/store";
// import { _ } from "$lib/config/i18n";
import { useConfiguratorProductsStore } from "$lib/store/configurator.products.store";

export function calculateAdditionalOptionTotalPrice(
    amount: number,
    unitPrice: number,
    isOneTimePayment: boolean,
    powerClass: number
) {
    if (isOneTimePayment) return Number((amount * unitPrice).toFixed(2));
    if (!powerClass || powerClass == 0) return 0;
    return Number(((amount * powerClass) / 1000).toFixed(2)) * unitPrice;
}

export function getAmountInKWP(amount: number, isUnitPrice: boolean, powerClass: number) {
    if (isUnitPrice) return amount;
    if (powerClass && powerClass > 0) return Number(((amount * powerClass) / 1000).toFixed(2));
    return 0;
}


export function addOption(product: Product, amount: number = 1, roofIndex?: number | 'all') {
    const configuratorStore = useConfiguratorStore();
    const configurationStoreValue = get(useConfiguratorStore());
    const products = get(useConfiguratorProductsStore());
    const effectiveValues = get(useEffectiveRoofStore());

    const modules = products.filter(
        (p) => p.active && p.type === ProductTypes.MODULE && p.id == configurationStoreValue.moduleComponent.moduleType
    )

    const powerClass =
        modules.length > 0 &&
            modules[0] &&
            modules[0].data &&
            (modules[0].data as { powerClass: number }).powerClass
            ? (modules[0].data as { powerClass: number }).powerClass
            : 0;

    // Use effective values from the global store
    const resolvedRoofIndex = roofIndex ?? effectiveValues.selectedRoof;
    const effectivePvSize = effectiveValues.effectivePvSize;
    const effectiveAmountOfModule = effectiveValues.effectiveAmountOfModule;

    const option: AdditionOptions = {
        name: product.name,
        unitPrice: 0,
        type: product.type,
        amount: 1,
        id: product.id,
        totalPrice: 0,
        pdfText: product.description,
        roofIndex: resolvedRoofIndex,
    };

    const unitPrice =
        product.price > 0 ? product.price : ((product.data as { price: number }).price ?? 0);

    option.unitPrice = unitPrice;
    switch (product.type) {
        case ProductTypes.ADDON: {
            const isOneTimePayment = product.price > 0 ? product.referenceUnit == ReferenceUnit.UNIT : (product.data as AddonData).type == 1;
            option.amount = getAmountInKWP(
                amount,
                isOneTimePayment,
                powerClass
            );
            option.totalPrice = calculateAdditionalOptionTotalPrice(
                amount,
                unitPrice,
                isOneTimePayment,
                powerClass
            );
            break;
        }

        case ProductTypes.ACCESSORY: {
            option.amount = 1;
            option.totalPrice = unitPrice;
            break;
        }

        case ProductTypes.INVESTER: {
            option.totalPrice =
                product.referenceUnit == ReferenceUnit.UNIT
                    ? unitPrice * amount
                    : unitPrice * effectivePvSize;
            option.amount = amount;
            break;
        }

        case ProductTypes.SUBSTRUCTURE: {
            const isOneTimePayment =
                product.referenceUnit == ReferenceUnit.UNIT || (product.data as AddonData).type == 1;
            if (isOneTimePayment) {
                option.amount = effectiveAmountOfModule ?? 0;
            } else {
                option.amount = getAmountInKWP(1, false, powerClass);
            }
            option.totalPrice = unitPrice * option.amount;
            break;
        }
        default:
            option.totalPrice =
                product.referenceUnit == ReferenceUnit.UNIT
                    ? unitPrice * amount
                    : unitPrice * effectivePvSize;
            option.amount = amount;
            break;
    }

    const surcharge = product.surchargePercentage ?? 0;
    option.totalPrice = Number(((option.totalPrice ?? 0) * (1 + surcharge / 100)).toFixed(2));
    configuratorStore.update((x) => {
        x.additionOptions.push(option);
        return x;
    });

    // toast.success(
    //     `${option.amount} ${(product.type === ProductTypes.INVESTER || product.referenceUnit == ReferenceUnit.UNIT || product.type === ProductTypes.ACCESSORY) ? 'x' : 'kWp'} ${option.name} ${get(_)('has_been_added')}`
    // );
}
